"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimQuestRewardResponseToJSON = exports.ClaimQuestRewardResponseFromJSONTyped = exports.ClaimQuestRewardResponseFromJSON = void 0;
var _1 = require("./");
function ClaimQuestRewardResponseFromJSON(json) {
    return ClaimQuestRewardResponseFromJSONTyped(json, false);
}
exports.ClaimQuestRewardResponseFromJSON = ClaimQuestRewardResponseFromJSON;
function ClaimQuestRewardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rewards': (json['rewards'].map(_1.RewardResponseObjectFromJSON)),
    };
}
exports.ClaimQuestRewardResponseFromJSONTyped = ClaimQuestRewardResponseFromJSONTyped;
function ClaimQuestRewardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rewards': (value.rewards.map(_1.RewardResponseObjectToJSON)),
    };
}
exports.ClaimQuestRewardResponseToJSON = ClaimQuestRewardResponseToJSON;
